import ContentSix from '../Section/ContentSix';

const ThemeSix = ({ attributes, setAttributes }) => {
    return (
        <div className='ThemeSixWrapper faq-container-style'>
            <ContentSix
                attributes={attributes}
                setAttributes={setAttributes}
            />
        </div>
    );
};

export default ThemeSix;